var defaultProps = {};
var styleOverrides = {
  root: {
    '& > .MuiToolbar-root': {
      minHeight: 35
    }
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};